import {
    ArrowRightEndOnRectangleIcon, HeroExclamationTriangleIcon,
} from 'components/Icon'
import {
    ModalContent, ModalFooter, ModalHeader,
} from '../ModalView'
import {
    fieldset, footerContent, modalContent,
} from './styles'
import Button from 'components/Button'
import {Icon} from 'components/Icon/types'
import {LeaveChannelModalProps} from './types'
import Modal from '../Modal'
import React from 'react'
import {styled} from 'stitches/config'
import {useTranslation} from 'react-i18next'

const StyledFieldset = styled('fieldset', fieldset)
const StyledModalContent = styled('div', modalContent)
const StyledFooterContent = styled('div', footerContent)

const LeaveChannelPromiseModalView = (props: LeaveChannelModalProps): React.ReactElement => {
    const {
        onResolve, onReject, channelName, inProgress,
    } = props
    const {t} = useTranslation()

    const handleSubmitModal = () => {
        onResolve?.()
    }
    const handleCloseModal = () => {
        onReject?.()
    }

    return (
        <Modal onClose={handleCloseModal}>
            <ModalHeader icon={HeroExclamationTriangleIcon as unknown as Icon} title={`${t('Leave channel')}?`} type='error' />
            <ModalContent>
                <StyledModalContent>
                    <StyledFieldset>
                        <div> {t('You are about to leave from channel')} <strong>{channelName}</strong>.</div>
                    </StyledFieldset>
                    <StyledFieldset>
                        <div>{t('You can\'t return without a new invite. You will lose channel conversation history.')}</div>
                    </StyledFieldset>
                </StyledModalContent>
            </ModalContent>
            <ModalFooter>
                <StyledFooterContent>
                    <Button onPress={handleCloseModal} size='large' tabIndex={-1} text={t('Cancel')} />
                    <Button color='filled' disabled={inProgress} iconLeft={ArrowRightEndOnRectangleIcon} onPress={handleSubmitModal} size='large' tabIndex={0} text={t('Leave channel')} />
                </StyledFooterContent>
            </ModalFooter>
        </Modal>
    )
}

export default LeaveChannelPromiseModalView
